// extracted by mini-css-extract-plugin
module.exports = {"methodBtn":"SignUp_methodBtn__1F4nl","methodIconBox":"SignUp_methodIconBox__fXYiY","methodLabel":"SignUp_methodLabel__2SRKd","changeMethodBtn":"SignUp_changeMethodBtn__2MR2u"};